var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 22.0454C5.92 22.0454 5.73 22.0054 5.57 21.9054C5.22 21.7154 5 21.3454 5 20.9454V2.09537C5 1.69537 5.22 1.32538 5.57 1.13538C5.92 0.945375 6.35 0.955375 6.68 1.16537L21.71 10.5854C22.03 10.7854 22.22 11.1354 22.22 11.5154C22.22 11.8954 22.03 12.2454 21.71 12.4454L6.68 21.8654C6.5 21.9754 6.3 22.0354 6.1 22.0354V22.0454ZM7.2 4.08537V18.9654L19.07 11.5254L7.2 4.08537Z",
    fill: "#6C74B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.c9c46a64c236e7d20bdb25d2fa8d0da9.svg";
export { ForwardRef as ReactComponent };